export default "__VITE_ASSET__BIgoDgj5__"